(function(){
  function init(){
    const story=document.querySelector('.bm-family-story');
    if(!story)return;

    const desktop=window.matchMedia('(min-width:1024px)');
    const zoomImages=Array.from(story.querySelectorAll('[data-bm-family-enlarge]'));
    let dialog,dialogImage,lastTrigger,previousOverflow;
    function closeZoom(){if(dialog&&dialog.open)dialog.close();}
    function createDialog(){
      if(dialog)return;
      dialog=document.createElement('dialog');
      dialog.className='bm-family-image-dialog';
      dialog.setAttribute('aria-label','Family Bed materials and construction — enlarged image');
      const close=document.createElement('button');
      close.type='button';
      close.className='bm-family-image-dialog__close';
      close.setAttribute('aria-label','Close enlarged image');
      close.textContent='×';
      close.addEventListener('click',closeZoom);
      dialogImage=document.createElement('img');
      dialog.append(close,dialogImage);
      story.append(dialog);
      dialog.addEventListener('click',function(event){if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeZoom();}});
      dialog.addEventListener('close',function(){document.body.style.overflow=previousOverflow;if(lastTrigger&&lastTrigger.isConnected)lastTrigger.focus();});
    }
    function openZoom(image,trigger){
      if(!desktop.matches)return;
      createDialog();
      dialogImage.src=image.currentSrc||image.src;
      dialogImage.alt=image.alt;
      dialog.setAttribute('aria-label',image.alt+' — enlarged image');
      lastTrigger=trigger;
      previousOverflow=document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow='hidden';
    }
    function syncZoom(){
      if(!desktop.matches)closeZoom();
      zoomImages.forEach(function(image){
        const existing=image.closest('.bm-family-image-zoom');
        if(desktop.matches&&!existing){
          const button=document.createElement('button');
          button.type='button';
          button.className='bm-family-image-zoom';
          button.setAttribute('aria-label','Enlarge '+image.alt);
          button.setAttribute('aria-haspopup','dialog');
          image.replaceWith(button);
          button.append(image);
          const hint=document.createElement('span');
          hint.className='bm-family-image-zoom__hint';
          hint.textContent='Click to enlarge';
          hint.setAttribute('aria-hidden','true');
          button.append(hint);
          button.addEventListener('click',function(){openZoom(image,button);});
        }else if(!desktop.matches&&existing){existing.replaceWith(image);}
      });
    }
    syncZoom();
    desktop.addEventListener('change',syncZoom);
    const mobile=window.matchMedia('(max-width:767px)');
    const graphic=story.querySelector('.bm-family-story__graphic');
    if(graphic){
      graphic.open=mobile.matches;
      mobile.addEventListener('change',function(event){graphic.open=event.matches;});
    }
    document.querySelectorAll('[data-bm-family-snap],[data-bm-family-policy]').forEach(function(link){
      link.addEventListener('click',function(event){
        event.preventDefault();
        const policy=link.hasAttribute('data-bm-family-policy');
        const availableWidth=window.screen.availWidth||window.innerWidth;
        const availableHeight=window.screen.availHeight||window.innerHeight;
        const availableLeft=window.screen.availLeft||0;
        const availableTop=window.screen.availTop||0;
        const width=Math.min(policy?900:560,mobile.matches?window.innerWidth:Math.max(1,availableWidth-32));
        const height=Math.min(policy?900:950,mobile.matches?window.innerHeight:Math.max(1,availableHeight-48));
        const left=Math.round(Math.min(availableLeft+availableWidth-width,Math.max(availableLeft,window.screenX+(window.outerWidth-width)/2)));
        const top=Math.round(Math.min(availableTop+availableHeight-height,Math.max(availableTop,window.screenY+(window.outerHeight-height)/2)));
        const features='popup=yes,width='+width+',height='+height+',left='+left+',top='+top+',scrollbars=yes,resizable=yes';
        const popup=window.open(link.href,policy?'bmFamilyPolicy':'bmFamilySnap',features);
        if(popup){popup.opener=null;popup.focus();}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

